import * as React from 'react';
const cardContext = React.createContext(undefined);
/**
 * @internal
 */
export const cardContextDefaultValue = {
  selectableA11yProps: {
    referenceId: undefined,
    setReferenceId() {
      /* Noop */},
    referenceLabel: undefined,
    setReferenceLabel() {
      /* Noop */}
  }
};
/**
 * @internal
 */
export const CardProvider = cardContext.Provider;
/**
 * @internal
 */
export const useCardContext_unstable = () => {
  var _React_useContext;
  return (_React_useContext = React.useContext(cardContext)) !== null && _React_useContext !== void 0 ? _React_useContext : cardContextDefaultValue;
};